import { UpdateTeamRequest, UpdateTeamResponse, apiPut } from 'api';

export const updateTeam = (request: UpdateTeamRequest): Promise<UpdateTeamResponse> =>
  apiPut<UpdateTeamResponse, UpdateTeamRequest>(`admin/teams/${request.id}`, request);
